import { GoogleSigninResponse } from "./redux/services/api/types";

declare global {
  interface Window { 
    googleLoginHandler: (response: GoogleSigninResponse) => void; 
    userLogoutHandler: () => void;
    canShowQuestionnaire: boolean;
  }
}

export interface User {
  id?: number;
  uuid: string;
  name: string;
  lastName: string;
  fullName: string;
  email: string;
  picture: string;
  isPremium: boolean;
  new?: boolean;
}

export enum SubscriptionState {
  WAITING_FOR_PAYMENT = 'waiting_for_payment',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
}

export function toSubscriptionState(value: string): SubscriptionState {
  switch (value) {
    case SubscriptionState.WAITING_FOR_PAYMENT:
      return SubscriptionState.WAITING_FOR_PAYMENT;
    case SubscriptionState.ACTIVE:
      return SubscriptionState.ACTIVE;
    case SubscriptionState.EXPIRED:
      return SubscriptionState.EXPIRED;
    case SubscriptionState.CANCELLED:
    default:
      return SubscriptionState.CANCELLED;
  }
}

export interface Subscription {
  id: string;
  userId: string;
  planId: string;
  state: SubscriptionState;
  startedAt: string;
  endsAt: string;
  showNotification?: boolean;
}

export enum UserAccountEvents {
  LOGGED = 'user-logged',
  LOGOUT = 'user-logout',
}
